import PeopleSchemaSerializer from './base';
import DataType from '@linc-technologies/linced-common/enums/data-type';
import InputType from '@linc-technologies/linced-common/enums/input-type';

export default class Field extends PeopleSchemaSerializer {
  serializeIntoHash(hash) {
    super.serializeIntoHash(...arguments);
    let dataType = 0;
    switch (hash.field.inputType) {
      case InputType.CHECKBOX:
      case InputType.MULTI_SELECT:
        dataType = DataType.LIST;
        break;
      case InputType.NUMBER:
        // Already set via the UI.
        dataType = hash.field.dataType;
        break;
      case InputType.SELECT:
        dataType = hash.field.dataType || DataType.STRING;
        break;
      case InputType.SWITCH:
        dataType = DataType.BOOLEAN;
        break;
      default:
        dataType = DataType.STRING;
        break;
    }
    hash.field.dataType = dataType;
  }
}
